import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { BLANK_PAGE_ROUTE } from '@routes';
import V2SettingsIframe from '@aware/common/v2-settings-iframe';

const EditMyTeams = () => {
  const { pathname, state: locationState = {} } = useLocation();
  const history = useHistory();
  const [newTeamId, setNewTeamId] = useState('');

  /**
   *  Get newTeamId from location state, store it in state, and remove it from history so it's no longer set as
   * user navigates around
   */
  useEffect(() => {
    if (locationState?.newTeamId) {
      setNewTeamId(locationState.newTeamId);
      history.replace(pathname, {});
    }
  }, []);

  const detailSrcRoute = newTeamId
    ? `/Webmanager/TeamConfig.aspx&tpid=${newTeamId}`
    : BLANK_PAGE_ROUTE;

  return (
    <V2SettingsIframe
      iframeSrc={`/aware/?embed=1&leftSrc=/Webmanager/TeamList.aspx&detailsSrc=${detailSrcRoute}`}
      title="Edit My Teams"
      onLoadCallback={iframe => {
        if (iframe?.contentDocument) {
          iframe.contentDocument
            .getElementById('panelleft')
            .classList.add('MainPanelLeftWider');
        }
      }}
    />
  );
};

export default EditMyTeams;
